import React from 'react';

import { Box, Text } from '@opendoor/bricks-next';
import { IconChevronRight } from '@tabler/icons-react';
import { motion } from 'framer-motion';

interface MobileMegaNavButtonProps {
  itemName: string;
  onClick: () => void;
  isLast?: boolean;
}

export const MobileMegaNavButton: React.FC<MobileMegaNavButtonProps> = ({
  itemName,
  onClick,
  isLast,
}) => {
  const buttonProps = { onPress: onClick } as any;

  return (
    <Box
      tag={motion.li as any}
      borderBottomWidth={isLast ? 0 : 1}
      borderColor="$borderPrimary"
      $largerThanSM={{ display: 'none' }}
    >
      <Box
        tag="button"
        {...buttonProps}
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        paddingTop="$8x"
        paddingBottom="$8x"
        paddingLeft="$12x"
        paddingRight="$9x"
        width="100%"
        cursor="pointer"
      >
        <Text tag="span" typography="$bodyMedium">
          {itemName}
        </Text>
        <Text tag="span" typography="$bodySmall" color="$contentPrimary">
          <IconChevronRight size={24} />
        </Text>
      </Box>
    </Box>
  );
};
